export const ORDERS_WIDTH = 400;
export const STARS_PERCENTAGE = 0.6;
